const config = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_8XxL5Xk9m",
    userPoolWebClientId: "32ajguesjv06t3pl0svemrrspt",
  },
};

export default config;
